"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _BOILogoNoSpace = require("./BOILogoNoSpace");

var _BOILogoNoSpace2 = _interopRequireDefault(_BOILogoNoSpace);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _BOILogoNoSpace2.default;